export function assertNever(x: never) {
  // eslint-disable-next-line no-console
  console.error('Unexpected value: ', x);
}
